import { goBack } from 'connected-react-router';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import Breadcrumbs from './Breadcrumbs';
import LoadingPanel from './LoadingPanel';
import { selectors, actions } from './../../modules/form';
import { Icon } from './../../common/components/';
import classnames from 'classnames';
import Box from '../customer/profilePage/components/Box';
import BoxesRow from '../customer/profilePage/components/BoxesRow';
import ActionButton from './ActionButton';

const minStepNumber = 1;

const calculateNextStep = (stepNumber, isNextStep, maxStepNumber) => {
    let step = isNextStep ? stepNumber + 1 : stepNumber - 1;
    if (step < minStepNumber)
        step = minStepNumber;
    if (step > maxStepNumber)
        step = maxStepNumber;
    return step;
}

const FormContainer = ({ formName, formTitle, stepNumber, stepsList, confirmStepAction,
    changeStepHandler, isValid, onBackHandler, onAbortHandler, clearFormDataHandler, className, showConfirmationScreen = 'false',
    confirmationScreenBody, isFormCompleted, setFormCompletedHandler }) => {
    const formContainerClass = classnames('formContainer', className);
    const maxStepNumber = stepsList.length;
    const stepBody = stepsList[stepNumber - 1].stepBody;
    const nextButtonText = stepsList[stepNumber - 1].stepNextButtonText;
    const isFirstStep = stepNumber === minStepNumber;
    return (
        <BoxesRow className={formContainerClass}>
            <Box label={formTitle}>
                {maxStepNumber > 1 && <Breadcrumbs steps={stepsList} currentStep={stepNumber} formTitle={formTitle} />}
                {(showConfirmationScreen && isFormCompleted) &&
                    <div>
                        {confirmationScreenBody}
                    </div>
                }
                {!(showConfirmationScreen && isFormCompleted) &&
                    <div>
                        <div className="formBody clearfix">
                            {stepBody}
                        </div>
                        <div className="formButtonRow">
                            {isFirstStep &&
                                <ActionButton
                                    to={null}
                                    title='Avbryt'
                                    className="big"
                                    action={e => onBackHandler(onAbortHandler, formName)}
                                />
                            }
                            {!isFirstStep &&
                                <ActionButton
                                    to={null}
                                    title='Tilbake'
                                    className="big"
                                    action={e => changeStepHandler(stepNumber, maxStepNumber, false, formName)}
                                />
                            }
                            {stepNumber < maxStepNumber &&
                                <ActionButton
                                    to={null}
                                    title="Neste"
                                    className="right-button big"
                                    action={e => changeStepHandler(stepNumber, maxStepNumber, true, formName)}
                                    active={isValid}
                                />
                            }
                            {stepNumber === maxStepNumber &&
                                <ActionButton
                                    to={null}
                                    title={nextButtonText ? nextButtonText : "Ok"}
                                    className="right-button big green"
                                    action={e => {
                                        if (showConfirmationScreen)
                                            setFormCompletedHandler(formName, true);
                                        confirmStepAction(formName)
                                        if (!showConfirmationScreen && clearFormDataHandler)
                                            clearFormDataHandler();
                                    }}
                                />
                            }
                        </div>
                    </div>
                }
            </Box>
        </BoxesRow>
    );
};

FormContainer.propTypes = {
    formName: PropTypes.string.isRequired,
}

const mapStateToProps = (state, props) => ({
    stepNumber: selectors.getFormStepNumber(state, props.formName),
    isFormCompleted: selectors.isFormCompleted(state, props.formName),
    isValid: props.stepsList[selectors.getFormStepNumber(state, props.formName) - 1].isStepValidSelector(state)
});

const mapDispatchToProps = (dispatch, props) => ({
    onBackHandler: (onAbortHandler, formName) => Promise.resolve(onAbortHandler(formName)).then(() => dispatch(goBack())),
    changeStepHandler: (stepNumber, maxStepNumber, isNextStep, formName) => dispatch(actions.ChangeFormStep(formName, calculateNextStep(stepNumber, isNextStep, maxStepNumber))),
    setFormCompletedHandler: (formName, value) => dispatch(actions.setFormCompleted(formName, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(FormContainer)
